import React, { useEffect, useMemo, useRef, useState } from "react";
import leftArrow from "../../../assets/images/left-arrow.svg";
import shareButton from "../../../assets/images/share-btn.svg";
import addedProduct from "../../../assets/images/added-product-icon.svg";
import shareStoreMedia1 from "../../../assets/images/media-1.svg";
import shareStoreMedia2 from "../../../assets/images/media-2.svg";
import shareStoreMedia3 from "../../../assets/images/media-3.svg";
import shareStoreMedia4 from "../../../assets/images/media-4.svg";
import shareStoreMedia5 from "../../../assets/images/media-5.svg";
import noStoreData from "../../../assets/images/store-no-data.svg";
import uploadIcon from "../../../assets/images/upload-icon.svg";
import pencilMark from "../../../assets/images/pencil-mark.svg";
import deleteMark from "../../../assets/images/delete-mark.svg";
import descriptionIcon from "../../../assets/images/description-icon.svg";
import Close_black from "../../../assets/close_black.svg";
import { getDiscardChanges, getOutOfStock, getSavedChanges, getStoreDetails, onDeleteProduct, onGetProducts, onsetProductorders, onStoreUpdate } from "../../../services";
import { useDispatch, useSelector } from 'react-redux'
import { useToast } from "../../../toast";
import $ from "jquery";
import Close_white from "../../../assets/white-close.svg";
import userImage from "../../../assets/profile.png";
import _ from 'lodash';
import { useHistory } from "react-router-dom";
import EditIcon from "../../../assets/edit-icon.svg";
import Header from "../../common/Header";
import { EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import IsLoadingHOC from "../../HOC/loader/IsLoadingHOC";
import StorePreviewShimmer from "./StorePreviewShimmer";
import CardShimmer from "../../common/CardShimmer";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { onJustReducerUpdate } from "../../../redux/action";
import { HANDLE_PROFILE_DETAILS } from "../../../redux/action_type";
import addedProductWhite from "../../../assets/images/added-product-icon-white.svg"
import { onHTMLParse } from "../../../utils/common";

const StorePreview = () => {
  const [product, setproduct] = useState([])
  const [tempProduct, setTempProduct] = useState([])
  const [deletedProduct, setDeletedProduct] = useState([])
  const [selectProduct, setSelectProduct] = useState({})
  const [storeDetails, setStoreDetails] = useState({})
  const [storeTempDetails, setStoreTempDetails] = useState({})
  const [storeTitle, setStoreTitle] = useState("")
  const [storeDescription, setStoreDescription] = useState("")
  const profileDetails = useSelector((state) => state.profileDetails)
  const toast = useToast()
  const listInnerRef = useRef();
  const [currPage, setCurrPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);
  const [lastList, setLastList] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [isReorder, setIsReorder] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isDiscard, setIsDiscard] = useState(false);
  const [isRedirectProduct, setIsRedirectProduct] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [productLoading, setProductLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true)
  const [maxLimit, setMaxlimt] = useState(false)
  const [storeImage, setStoreImage] = useState("")
  const [storeUploadImage, setStoreUploadImage] = useState("")
  const [isRedirectLocation, setIsRedirectLocation] = useState({})
  const isPathName = window.location.pathname

  const history = useHistory();
  const dispatch = useDispatch()

  const getStore = () => {
    setDetailLoading(true)
    getStoreDetails().then((res) => {
      setDetailLoading(false)
      if (res.status) {
        setStoreDetails(res.data)
        setStoreTempDetails(res.data)
        setStoreDescription(res?.data?.description)
        setStoreTitle(res?.data?.store_name)
        setStoreImage(res.data?.image)
      }
    })
  }
  useEffect(() => {
    const getStorageProduct = localStorage.getItem("isEditProduct")
    if (getStorageProduct && !JSON.parse(getStorageProduct)) {
      getOutOfStock().then((res) => {
        if (!res?.data?.instock) {
          $("#out-of-stock").modal("show")
        }
      })
    }
  }, [])

  useEffect(() => {
    window.oncontextmenu = function (event) {
      const pointerEvent = event
      if (pointerEvent.pointerType === 'touch') {
        return false;
      }
      return true;
    };
    getStore()
    const getStorageProduct = localStorage.getItem("isEditProduct")
    if (getStorageProduct && JSON.parse(getStorageProduct)) {
      setShowDelete(true)
      setIsUpdate(true)
      localStorage.setItem("isEditProduct", false)
    } else {
      getDiscardChanges()
    }
  }, [])

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (isUpdate) {
        onSaveClick()
        setIsRedirectLocation(location)
        return false
      }
      return true;
    });

    return () => {
      unblock();
    };
  }, [isUpdate]);

  useEffect(() => {
    dispatch(onJustReducerUpdate(showDelete, HANDLE_PROFILE_DETAILS))
    return () => {
      dispatch(onJustReducerUpdate(false, HANDLE_PROFILE_DETAILS))
    }
  }, [showDelete])

  useEffect(() => {
    if (isPathName === "/store-preview") {
    const unloadCallback = (event) => {
      event.preventDefault();
      if (isUpdate) {
        event.returnValue = "";
      } else {
        return null
      }
    };

    window.addEventListener("beforeunload", unloadCallback);
    return () => window.removeEventListener("beforeunload", unloadCallback);
  }
  }, [isUpdate]);

  useEffect(() => {
    if (isRedirectProduct && !isUpdate) {
      localStorage.setItem("product_count", "0")
      // localStorage.setItem("isEditProduct", true)
      setIsRedirectProduct(false)
      window.open("https://stage-creatorpro.myjosh.in/affiliate_store/index?d_type=web&src=add-product", "_self")
    }
  }, [isRedirectProduct, isUpdate])

  useEffect(() => {
    if (isDiscard && !isUpdate) {
      localStorage.setItem("product_count", "0")
      // localStorage.setItem("isEditProduct", true)
      setIsDiscard(false)
      window.open("https://stage-creatorpro.myjosh.in/affiliate_store/index?d_type=web&src=add-product", "_self")
    }
  }, [isDiscard, isUpdate])
  useEffect(() => {
    if (!_.isEmpty(profileDetails)) {
      if (profileDetails?.cp_creator_domains?.length === 0) {
        history.push("/onboarding");
      }
    }
  }, [profileDetails])

  useEffect(() => {
    window.removeEventListener("scroll", onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [currPage]);

  useEffect(() => {
    const fetchData = async () => {
      let payload = {
        page: currPage - 1
      }
      if (currPage === 1) {
        setIsLoading(true)
      }
      setProductLoading(true)
      const res = await onGetProducts(payload)
      setProductLoading(false)
      setIsLoading(false)
      if (res?.totalItems) {
        setTotalProducts(res.totalItems)
      }
      if (!res.data.length) {
        setLastList(true);
        return;
      }
      setPrevPage(currPage);
      setTempProduct([...tempProduct, ...res.data])
      setproduct([...product, ...res.data]);
    };
    if (!lastList && prevPage !== currPage) {
      fetchData();
    }
  }, [currPage, lastList, prevPage, product]);

  useEffect(() => {
    if (isRedirectLocation?.pathname === "/dashboards" && !isUpdate) {
      $("#save-store").modal("hide")
      history.push(isRedirectLocation.pathname)
      setIsRedirectLocation({})
    }
  }, [isRedirectLocation, isUpdate])

  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop
    const scrollHeight = document.documentElement.scrollHeight
    const clientHeight = document.documentElement.clientHeight
    if (scrollTop + clientHeight >= scrollHeight) {
      setCurrPage(currPage + 1)
    }
  };
  const onCopyLink = () => {
    if (storeDetails?.status) {
      navigator.clipboard.writeText(`${window.location.origin}/${profileDetails?.cp_creator_domains[0]?.domain_name}`);
      toast.buttomOpen("Link copied successfully");
    } else {
      toast.buttomOpen("Please make your store online in order to share the link")
    }
  }

  const onEditstore = () => {
    setShowDelete(true)
  }
  const onSaveClick = () => {
    $("#save-store").modal("show")
  }
  const onRemove = () => {
    const removedProduct = product.find(a => a.cart_product_id === selectProduct?.cart_product_id)
    if (!_.isEmpty(removedProduct)) {
      setIsUpdate(true)
    }
    setDeletedProduct([...deletedProduct, removedProduct])
    const tempRemovedProduct = product.filter(a => a.cart_product_id !== selectProduct?.cart_product_id)
    setproduct(tempRemovedProduct)
    if (tempRemovedProduct?.length <= 10 && !lastList) {
      setCurrPage(currPage + 1)
    }
    toast.buttomOpen(`${removedProduct?.pro_name || ""} removed from store`)
  }
  const onSelect = (val) => {
    setSelectProduct(val)
  }
  const onSaveProductDetails = () => {
    onSaveDetail()
  }
  const onSaveDetail = async () => {
    if (!storeTitle || storeTitle === "") {
      toast.buttomOpen("Add store name")
      return
    }
    let formData = new FormData();
    formData.append("store_name", storeTitle)
    formData.append("id", storeDetails.id)
    formData.append("description", storeDescription)
    if (storeImage === "") {
      formData.append("image", "")
      formData.append("is_removeProfilePic", true)
    } else if (storeImage) {
      formData.append("image", storeUploadImage)
    }
    if (deletedProduct?.length > 0) {
      await onDeleteProduct(deletedProduct?.map(a => a.cart_product_id) || [])
    }
    if (isReorder) {
      await onsetProductorders({ product_id: product?.map(a => a.cart_product_id) })
      setIsReorder(false)
    }
    await getSavedChanges()
    onStoreUpdate(formData).then((res) => {
      if (res.status) {
        setShowDelete(false)
        $("#edit-details").modal("hide")
        getStore()
        setLastList(false)
        setDeletedProduct([])
        toast.buttomOpen("Details saved")
        setIsUpdate(false)
      } else {
        toast.buttomOpen(res.message)
      }
    })
  }

  const onResetData = () => {
    setStoreDescription(storeDetails?.description)
    setStoreTitle(storeDetails?.store_name)
  }

  const onRemoveCurrentPic = () => {
    $("#choose-store-pic").modal("hide")
    setStoreImage("")
    setIsUpdate(true)
    setStoreUploadImage("")
  }

  const goToAffiliate = () => {
    history.push('/affiliate-dashboard')
  }
  const onFileChange = (e) => {
    $("#choose-store-pic").modal("hide")
    if (e.target && e.target.files[0]) {
      setIsUpdate(true)
      setStoreImage(URL.createObjectURL(e.target.files[0]));
      setStoreUploadImage(e.target.files[0])
    }
  };
  const onLocalSave = () => {
    if (!storeTitle || storeTitle === "") {
      toast.buttomOpen("Add store name")
      return
    }
    setIsUpdate(true)
    setStoreDetails({ ...storeDetails, store_name: storeTitle, description: storeDescription })
    $("#edit-details").modal("hide")
  }

  const onAddProduct = () => {
    if (isUpdate || isReorder) {
      setIsRedirectProduct(true)
      setIsDiscard(true)
      onSaveClick()
      return
    }
    if (!isReorder && !isUpdate) {
      localStorage.setItem("product_count", "0")
      // localStorage.setItem("isEditProduct", true)
      window.open("https://stage-creatorpro.myjosh.in/affiliate_store/index?d_type=web&src=add-product", "_self")
      return
    }
    // $("#rearrange-product").modal("show")
  }
  const onBack = () => {
    // if (isUpdate) {
    //   onSaveClick()
    //   return
    // }
    // if (showDelete) {
    //   setShowDelete(false)
    //   return
    // }
    history.goBack()
  }
  const onChangesDiscard = async () => {
    await getDiscardChanges().then(() => {
      setCurrPage(1)
      setLastList(false)
      setPrevPage(0)
      setproduct([])
      getStore()
    })
    setIsRedirectProduct(false)
    setShowDelete(false)
    setIsUpdate(false)
    setDeletedProduct([])
  }
  const onForceRedirect = () => {
    setIsUpdate(false)
    return window.open("https://stage-creatorpro.myjosh.in/affiliate_store/index?d_type=web&src=add-product", "_self")
  }

  const SortableItem = SortableElement(({ val, index }) => {
    return (
      <div key={index} className={`prod_card_container col-md-3 prevent-select`}
        onClick={() => onSelect(val)}>
        <div className="store-card">
          <div className="drag-overlay"></div>
          {!JSON.parse(val?.is_status) && <div className="out-of-stock-bar">
            <h2> Out of stock</h2>
          </div>}
          {showDelete && <img className="delete-card" src={deleteMark} alt="" data-toggle="modal" data-target="#remove-store" />}
          <div className={val?.source==="cuelinks"?`product-image-store cuelink-images`: `product-image-store`}>
            <img src={val.image} alt="" width={"100%"} height={"100%"} />
          </div>
          <div className="product-details-wrap">
            <div className="added-product">
              <img src={!JSON.parse(val?.is_status) ? addedProductWhite : addedProduct} alt="" />
            </div>
            <div className="product-name">{val.pro_name}</div>
            <div className="product-description" dangerouslySetInnerHTML={{ __html: onHTMLParse(val?.pro_desc) }} >
            </div>
            {val.was_price === "" && val.price === "" ? "" :
              <div className="product-price">
                {" "}
                {val.was_price === val.price ? "" : <span className="strike-price">
                  {" "}
                  {val.was_price === "" ? <strike>0</strike> : <strike>{val.was_price}</strike>}
                </span>}{" "}
                {val.price === "" ? <span className="original-price">₹0</span> : <span className="original-price">₹{val.price}</span>}
                {val.was_price === val.price ? <span className="off-price"></span> : !val.price || val.was_price === "" || val.was_price===null ? <span className="off-price">0% OFF</span> : <span className="off-price">{`(${(Math.round((val.price / val.was_price) * 100) - 100) * -1}% OFF)`} </span>}
              </div>
            }
          </div>
        </div>
      </div>
    )
  });

  const SortableList = SortableContainer(({ items }) => {
    return (
      <div className="row">
        {
          items?.map((val, index) => (
            <SortableItem collection={JSON.parse(val?.is_status)} key={`item-${index}`} disabled={!showDelete || !JSON.parse(val?.is_status)} index={index} val={val} />
          ))
        }
      </div>
    );
  });

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const data = [...product];
    const item = data.splice(oldIndex, 1)[0];
    data.splice(newIndex, 0, item);
    setIsUpdate(true)
    setIsReorder(true)
    setproduct(data)
  };

  return (
    <>
      {/* <Header className="hide-mob-view" /> */}
      <div className="mobile-responsive-bar">
        <div className="mobile-header-wrap d-block d-md-none d-flex mob-header">
          {!showDelete ? <img className="leftArrow" src={leftArrow} onClick={() => onBack()} alt="" />
            : <div></div>}
          {showDelete ? <p className="editstoreText editText mb-0">Store Edit</p> : <p className="editstoreText previewText mb-0">Store Preview</p>}
          {showDelete ? <span className="textSave" onClick={onSaveClick}>Save</span> :
            <span onClick={onEditstore} className="textEdit">Edit</span>}
        </div>
      </div>

      <div className="main-wrapper" ref={listInnerRef}>
        {detailLoading || isLoading ? <StorePreviewShimmer />
          : <div className="custom-container">
            <div className="common-header-bar">
              {showDelete ? <h2>Store Edit</h2> : <h2>Store Preview</h2>}{" "}
              <div className="common-btn">
                {!showDelete && <button className="btn-green affiliateDash" onClick={goToAffiliate}>Go to Affiliate Dashboard</button>}
                {showDelete ? <button className="btn-green" onClick={onSaveClick}>Save</button> :
                  <button onClick={onEditstore} className="btn-gray">Edit</button>}
              </div>
            </div>
            <div className="edit-store">
              <div className="store-profile">
                <div className="store-image-wrap">
                  <img src={storeImage || userImage} alt="Store Image" />
                  <div className="upload-store-image" data-target="#choose-store-pic">
                    {/* <input type="file" name="" id="store-pic" /> */}
                    <label htmlFor="store-pic">
                      {" "}
                      {showDelete && <img className="editIcon" data-toggle="dropdown" src={EditIcon} alt="" />}
                      <div className="dropdown ">

                        <div className="dropdown-menu transform dropdownnew" >
                          <div className="dropdown-item borderLines" >
                            <input type="file" accept="image/*" onChange={onFileChange} id='upload2' />
                            <label htmlFor="upload2">Choose from library</label>
                          </div>
                          {storeImage && <div className="dropdown-item borderLines" onClick={onRemoveCurrentPic} >
                            <input type="button" id='upload3' />
                            <label htmlFor="upload3"> Remove current photo</label>
                          </div>}
                          <a className="dropdown-item">
                            Cancel
                          </a>
                        </div>
                      </div>
                      {showDelete && <img className="upIcon" data-toggle="modal" data-target="#choose-store-pic" src={uploadIcon} alt="" />}
                    </label>
                  </div>
                </div>
                <p className="storeName">

                  {storeDetails?.store_name}{" "}
                  {showDelete && <img className="edit-store-name" data-toggle="modal" data-target="#edit-details" src={pencilMark} alt="" />}

                  {/* <button data-toggle="modal" data-target="#edit-title-description" >Edit Popup</button> */}
                </p>
                <span>
                  {storeDetails?.description}
                </span>
              </div>
              <div className="store-cards-wrap">
                <div className="totalContent">
                  {product.length > 0 && <div className="totalProducts">{`${totalProducts - deletedProduct?.length} Products`} <span>{showDelete && "(Long Press to reorder products)"} </span></div>}
                  {product.length > 0 && <div className="longPress">{`${totalProducts - deletedProduct?.length} Products`} <span>{showDelete && "(Long Press to reorder products)"}</span></div>}
                  {(showDelete && product.length > 0) && (
                    <div className="add-btn">
                      <button onClick={() => onAddProduct()} className="add-green">Add</button>{" "}
                    </div>
                  )}
                  {(showDelete && product.length > 0) && (
                    <div className="green-plus-btn">
                      <button onClick={() => onAddProduct()} className="green-black ">Add +</button>{" "}
                    </div>
                  )}
                </div>
                {product.length > 0 ?
                  <SortableList useWindowAsScrollContainer={true} pressDelay={500} axis={"xy"} items={product} lockOffset={"0%"} onSortEnd={onSortEnd} />
                  : !isLoading ? <div className="no-store-data">
                    <img src={noStoreData} alt="" />
                    <p className="heading-1">Hey, it feels so light!</p>
                    <span className="heading-2">
                      {" "}
                      There is nothing in your store. Lets's add some products.
                    </span>
                    {/* {(showDelete && product.length === 0) && ( */}
                    <div className="add-btn no-prod">
                      <button onClick={() => onAddProduct()} className="add-green add-produts-green">Add Products</button>{" "}
                    </div>
                    {/*  )} */}
                    {(showDelete && product.length === 0) && (
                      <div className="green-plus-btn add-btn no-prod ">
                        <button onClick={() => onAddProduct()} className="green-black ">Add+</button>{" "}
                      </div>
                    )}
                  </div> : <></>}
                {/* No Data Found HTML End Here */}
              </div>
            </div>
          </div>}
      </div>

      {!showDelete && <div className="share-btn" data-toggle="modal" data-target="#share-store">
        <img src={shareButton} alt="" />
      </div>}
      {!showDelete && (<div className="bottom-button-wrap">
        <div className="common-btn">
          <button
            className="btn-white"
            data-toggle="modal"
            data-target="#share-store"
          >
            Share
          </button>
          <button className="btn-green dashboard" onClick={goToAffiliate}>Go to Dashboard</button>
        </div>
      </div>)}
      {/* Share Store Popup Start Here */}
      <div
        className="modal fade share-store-popup select-picture-popup"
        id="share-store"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        data-backdrop="static"
        data-keyboard="false"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered custom-popup "
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Share your store link
              </h5>
              <div className="share-in-mob">Share</div>
              <button type="button" className="close" data-dismiss="modal">
                <span aria-hidden="true">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.375 1.375L13.625 13.625M1.37502 13.625L7.50002 7.5L13.625 1.375"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                </span>
              </button>
            </div>
            <div className="modal-body ">
              <div className="share-link-wrap">
                <div className={`form-gorup`}>
                  <input
                    className="form-control"
                    placeholder="Share Url"
                    type="text"
                    value={`${window.location.origin}/${profileDetails?.cp_creator_domains?.[0]?.domain_name}`}
                  />
                  <div className="common-btn">
                    <button className={`${!storeDetails?.status && "btn-disable"}`} onClick={onCopyLink}>Copy Link</button>
                  </div>
                </div>
                {storeDetails?.status && <div className="share-others">
                  <p> or share via</p>
                  <ul>
                    <li>
                      {" "}
                      <a>
                        <FacebookShareButton id="whatsapp-share" className='whatsapp-share' url={`${window.location.origin}/${profileDetails?.cp_creator_domains?.[0]?.domain_name}`}>
                          <img src={shareStoreMedia1} alt="" />
                        </FacebookShareButton>
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a href="javascript:void(0);">
                        <img src={shareStoreMedia2} alt="" />
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a href="javascript:void(0);">
                        <WhatsappShareButton id="whatsapp-share" className='whatsapp-share' url={`${window.location.origin}/${profileDetails?.cp_creator_domains?.[0]?.domain_name}`}>
                          <img src={shareStoreMedia3} alt="" />
                        </WhatsappShareButton>
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a href="javascript:void(0);">
                        <TwitterShareButton id="whatsapp-share" className='whatsapp-share' url={`${window.location.origin}/${profileDetails?.cp_creator_domains?.[0]?.domain_name}`}>
                          <img src={shareStoreMedia4} alt="" />
                        </TwitterShareButton>
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a href="javascript:void(0);">
                        <EmailShareButton id="whatsapp-share" className='whatsapp-share' url={`${window.location.origin}/${profileDetails?.cp_creator_domains?.[0]?.domain_name}`}>
                          <img src={shareStoreMedia5} alt="" />
                        </EmailShareButton>

                      </a>
                    </li>
                  </ul>
                </div>}
              </div>
            </div>
            <div className="modal-footer"></div>
          </div>
        </div>
      </div>
      {/* Share Store Popup End Here */}
      {/* Save Store Popup Start Here */}
      <div
        className="modal fade logout-popup-wrap save-store-popup"
        id="save-store"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        data-backdrop="static"
        data-keyboard="false"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered custom-popup "
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body ">
              <button type="button" data-dismiss="modal" className="close save-close">
                <span aria-hidden="true">
                  <img src={Close_black} alt="" />
                </span>
              </button>
              <div className="logout-card">
                <h2>Save changes</h2>
                <p>Do you want to save the changes you made?</p>
              </div>
            </div>
            <div className="modal-footer">
              <div className="common-btn">
                <button data-dismiss="modal" onClick={() => onSaveProductDetails()}>Save</button>
                <button data-dismiss="modal" onClick={() => onChangesDiscard()}>Discard</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Save Store Popup End Here */}
      {/* Remove Store Popup Start Here */}
      <div
        className="modal fade logout-popup-wrap save-store-popup"
        id="remove-store"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        data-backdrop="static"
        data-keyboard="false"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered custom-popup "
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body ">
              <div className="logout-card">
                <h2>Remove Product</h2>
                <p>Are you sure you want to remove the product from your store?</p>
              </div>
            </div>
            <div className="modal-footer">
              <div className="common-btn">
                <button data-dismiss="modal" onClick={onRemove}>Remove</button>
                <button data-dismiss="modal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Remove Store Popup End Here */}
      {/* Choose Picture Popup Start Here */}
      <div
        className="modal fade logout-popup-wrap select-picture-popup"
        id="choose-store-pic"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        // data-backdrop="static"
        // data-keyboard="false"
        aria-hidden="true"
      >
        <div
          className="modal-dialog custom-popup "
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body ">
              <div className="upload-store-image-wrap">
                <ul>
                  <li> <input type="file" accept="image/*" name="" onChange={onFileChange} id="library-pic" /><label htmlFor="library-pic">Choose from library</label>
                  </li>
                  {/* <li><input type="file" name="" id="photo-pic" /><label htmlFor="photo-pic">Take photo</label></li> */}
                  {storeImage && <li><input name="" onClick={onRemoveCurrentPic} id="current-pic" /><label htmlFor="current-pic">Remove current photo</label></li>}
                </ul>
              </div>
            </div>
            <div className="modal-footer">
              <div className="common-btn">
                <button data-dismiss="modal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Choose Picture Popup End Here */}
      <div
        className="modal fade edit-profile select-picture-popup"
        id="edit-details"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        data-backdrop="static"
        data-keyboard="false"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered custom-popup modal-fullscreen-xl aboutus-popup"
          role="document"
        >
          <div className="modal-content ">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit Details
              </h5>
              <div className="share-in-mob"> Add Details</div>
              <button type="button" className="close" >
                <span className="displaySpan" aria-hidden="true">
                  <img src={Close_white} onClick={onResetData} data-dismiss="modal" alt="" />
                  <span className="done-mobile-des" onClick={onLocalSave}>Done</span>
                </span>
              </button>
            </div>
            <div className="modal-body ">
              <div className="edit-profile-wrap">
                <div className="profile-form-wrap">
                  <div className="form-group">
                    <label className="labelContent" htmlFor="">
                      Enter Your Store Name
                    </label>
                    <input
                      className="form-control"
                      maxLength={30}
                      placeholder="Enter Your store Name"
                      type="text"
                      value={storeTitle}
                      onChange={(e) => setStoreTitle(e.target.value)}
                    />
                  </div>
                  <div className="form-group description-wrap">
                    <label className="labelContent" htmlFor="">
                      Add Description
                    </label>
                    <span className="text-counter">{storeDescription.length}/150</span>
                    <img className="done-mobile-des" src={descriptionIcon} alt="" />
                    <textarea className="form-control"
                      placeholder="Add Description"
                      value={storeDescription}
                      onChange={(e) => {
                        if (e?.target?.value?.length > 150 && !maxLimit) {
                          toast.buttomOpen(`Maximum description limit reached`)
                          setMaxlimt(true)
                        }
                        if (e?.target?.value?.length < 150 && maxLimit) {
                          setMaxlimt(false)
                        }
                        const message = e.target.value.slice(0, 150);
                        setStoreDescription(message)
                      }}></textarea>
                  </div>
                  <div className="confirm-btn">
                    <div className="common-btn">
                      <button onClick={onResetData} className="clear-btn">
                        Clear
                      </button>
                    </div>
                    <div className="common-btn">
                      <button onClick={onLocalSave}>Save</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Edit Description Popup Start Here */}
      <div
        className="modal fade logout-popup-wrap select-picture-popup"
        id="edit-title-description"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        // data-backdrop="static"
        // data-keyboard="false"
        aria-hidden="true"
      >
        <div className="modal-dialog custom-popup " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Details
              </h5>
              <button className="done-btn" data-dismiss="modal">Done</button>
            </div>
            <div className="modal-body ">
              <div className="edit-details-wrap">
                <div className="form-group">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Header"
                  />
                </div>
                <div className="form-group">
                  <img src={descriptionIcon} alt="" />
                  <div className="counter-char">0/150</div>
                  <textarea
                    className="form-control"
                    placeholder="Description"
                    name=""
                    id=""
                    cols="30"
                    rows="10"
                  ></textarea>

                </div>
              </div>
            </div>
            {/* <div className="modal-footer">
              <div className="common-btn">
                <button data-dismiss="modal">Cancel</button>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* Edit Description Popup End Here */}

      {/* product rearrangemodal starts here */}
      <div
        className="modal fade logout-popup-wrap save-store-popup"
        id="rearrange-product"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        data-backdrop="static"
        data-keyboard="false"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered custom-popup "
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body ">
              <div className="logout-card">
                <p>Are you sure you want to revert the changes and move to add product screen?</p>
              </div>
            </div>
            <div className="modal-footer">
              <div className="common-btn">
                <button onClick={() => onForceRedirect()}>Yes</button>
                <button data-dismiss="modal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* product rearrangemodal Ends here */}
      <div
        className="modal fade logout-popup-wrap save-store-popup"
        id="out-of-stock"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        data-backdrop="static"
        data-keyboard="false"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered custom-popup "
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body ">
              <button type="button" data-dismiss="modal" className="close save-close">
                <span aria-hidden="true">
                  <img src={Close_black} alt="" />
                </span>
              </button>
              <div className="logout-card">
                <h2>Item Out Of Stock</h2>
                <p>Some products are out of stock in your store. Kindly add new products so as to not miss out on your earning</p>
              </div>
            </div>
            <div className="modal-footer">
              <div className="common-btn">
                <button data-dismiss="modal" className='bg-btn'>Ok</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {productLoading && <CardShimmer />}
    </>
  );
}

export default StorePreview;